export const formatPartialPhoneNumber = (phone: string) => {
  const cleaned = phone.replace(/\D/g, '');
  const length = cleaned.length;

  if (!length) return '';

  const result = ['(', cleaned.substring(0, 3)];

  if (length > 3) {
    result.push(') ', cleaned.substring(3, 6));
  }

  if (length > 6) {
    result.push(' - ', cleaned.substring(6, 10));
  }

  return result.join('');
};
